import 'amazon-connect-streams';
import React, { memo, useRef, useEffect } from 'react';
import { genLogger, getCcpUrl, getAppLoginUrl } from '../utils';

const name = 'ConnectCCP';
const { log, error } = genLogger(name);

const ConnectCCP = () => {
  const ref = useRef(null);

  useEffect(() => {
    try {
      log('init start');
      if (typeof window === 'undefined') throw new Error('window missing');
      if (typeof window.connect === 'undefined') throw new Error('global connect missing');
      if (ref.current) {
        window.connect.core.initCCP(ref.current, {
          ccpUrl: getCcpUrl(),
          loginPopup: true,
          loginUrl: getAppLoginUrl(),
          loginPopupAutoClose: true,
          loginOptions: {
            autoClose: true,
            height: 600,
            width: 400,
            top: 0,
            left: 0
          },
          region: "ap-southeast-2",
          pageOptions: {
            enableAudioDeviceSettings: true,
            enablePhoneTypeSettings: true,
          },
          softphone: { 
            allowFramedSoftphone: true,      disableRingtone: false,       // optional, defaults to false
            //ringtoneUrl: "[your-ringtone-filepath].mp3", // optional, defaults to CCP’s default ringtone if a falsy value is set
            allowEarlyGum: true           // optional, default to true },
         },
         task: {
          disableRingtone: false, // optional, defaults to false
          //ringtoneUrl: "[your-ringtone-filepath].mp3" // optional, defaults to CCP's default ringtone if a falsy value is set
         },   
         ccpAckTimeout: 5000, // optional, defaults to 3000 (ms)
         ccpSynTimeout: 1000, // optional, defaults to 1000 (ms)
         ccpLoadTimeout: 1000 // optional, defaults to 5000 (ms)
        });
      }

      log('init end');
    } catch (e) {
      error(e);
    }
  }, [ref]);

  log('render');
  return (
    <div
      ref={ref}
      style={{ width: '100%', height: '100%', minWidth: 400 }}
      // style={{ minWidth: 400, minHeight: 480 }}
    />
  );
};

export default memo(ConnectCCP);
